// Client-side types + constants for src/contracts/agents-admin-api.json (v1.0).
// Side-effect free: the drift test imports this module without the Supabase client.
export const AGENTS_FN_PATH = "/functions/v1/admin-agents";
export const KILL_REASON_MAX = 500;

export { AGENT_STATES, RUN_STATES, ACK_STATES } from "../../supabase/functions/_shared/agents-types";
export type { AgentState, RunState, AckState, AgentsOverview } from "../../supabase/functions/_shared/agents-types";
